export const servicesUrl = {
  LOCAL: "https://localhost:54664/api",
  DEV: "https://mesc-service-dev.musea2.azure.ext.gm.com/ve-service/api",
  QA: "https://ve-service-api-ocf-qa.apps.pcfepgstg1mi.gm.com/api",
  TEST: "https://ve-service-api-ocf-test.apps.pcfepgstg1mi.gm.com/api",
  PERF: "https://ve-service-api-ocf-perf.apps.pcfepgstg1mi.gm.com/api",
  PROD: "https://mesc-service.musea2.azure.ext.gm.com/ve-service/api",
};

/**
 *
 */
export const mescUrl = {
  LOCAL: "http://localhost.gm.com/",
  DEV: "https://mesc-dev.musea2.azure.ext.gm.com/m",
  QA: "https://mesc-ui-ocf-qa.apps.pcfepgstg1mi.gm.com",
  TEST: "https://mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com",
  PERF: "https://mesc-ui-ocf-perf.apps.pcfepgstg1mi.gm.com",
  PROD: "https://mesc.musea2.azure.ext.gm.com/",
};

export const veInfo = {
  route: "/VE",
  title: "VE",
  subtitle: "Virtal Engineering",
  description: "Virtual Engineering",
  image: "image-ve",
  version: "0.0.0.1",
  revisionDate: "2019-01-22T11:15:21+00:00",
  services: servicesUrl,
};





